import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SectionCardVariant =
  | 'users' | 'roles' | 'categories' | 'suppliers' | 'subscription'
  | 'primary' | 'classification' | 'market' | 'challenges' | 'variable' | 'fixed'
  | 'schedule' | 'exceptions' | 'employees' | 'salaries';

@Component({
  selector: 'app-section-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './section-card.component.html',
  styleUrls: ['./section-card.component.css']
})
export class SectionCardComponent {
  @Input() variant: SectionCardVariant = 'primary';
  @Input() icon: string = '';
  @Input() title: string = '';
  @Input() subtitle?: string;
  @Input() dense: boolean = false;
}
